import React, { useState } from "react";
import Contact from "./footer/Contact";
import FooterLinks from "./footer/FooterLinks";

import { setCookie, getCookie } from "../utils/helpers";

function Footer({ contactRef }) {
  const year = new Date().getFullYear();
  const consentActive = getCookie("cookie_accepted");
  const [cookieConsent, setCookieConsent] = useState(consentActive);

  const handleCookieConsent = () => {
    setCookie("cookie_accepted", true, 1);
    setCookieConsent(getCookie("cookie_accepted"));
  };
  return (
    <footer ref={contactRef} className="position-relative pt-5 bg-gray-100">
      <div className="container mt-5">
        <div className="row">
          <Contact />
          <FooterLinks />
          <div className="col-12">
            <div className="px-3 d-flex align-items-center justify-content-center my-3">
              <p className="fs-14 text-center">
                &copy; {year} Tanaad Money Ltd, a company registered in England
                and Wales. Reg no 11100093. All Rights Reserved. Tanaad is is a
                PSD agent with FCA number 842687
              </p>
            </div>
          </div>
        </div>
      </div>
      {!cookieConsent && (
        <div className="position-absolute start-0 bottom-0 bg-dark-tranparent-85 p-2">
          <p className="text-white">
            <strong>This site uses cookies</strong> – small text files that are
            placed on your machine to help the site provide a better user
            experience. In general, cookies are used to retain user preferences,
            store information for things like shopping carts, and provide
            anonymised tracking data to third party applications like Google
            Analytics. As a rule, cookies will make your browsing experience
            better. However, you may prefer to disable cookies on this site and
            on others. The most effective way to do this is to disable cookies
            in your browser. We suggest consulting the Help section of your
            browser or taking a look at the About Cookies website which offers
            guidance for all modern browsers{" "}
            <button
              onClick={handleCookieConsent}
              className="btn btn-sm btn-primary boxshadow-none outline-none mx-2"
            >
              I agree
            </button>
          </p>
        </div>
      )}
    </footer>
  );
}

export default Footer;
